import { RotatingArrows } from '@creditornot/cb-icons';
import { colors, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import styled, { keyframes } from 'styled-components';

import { Typography as T } from 'common/typography';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
`;

export const HeaderContainer = styled.div`
  display: flex;
  height: 104px;
  padding: 44px 24px 16px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  justify-content: space-between;
  align-items: end;
`;

export const Header = styled(T.Heading2)`
  display: flex;
  flex-direction: column;
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const Content = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

export const ListContainer = styled.div`
  width: 100%;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  padding: 24px 48px;
`;

const spin = keyframes`
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
`;

export const SpinningRotatingArrows = styled(RotatingArrows)`
  animation-name: ${spin};
  animation-duration: 5000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  height: 12px;
  fill: ${colors.wolt100};
`;
